import Select from "react-select";
import { useContext } from "react";
import { FormikContext } from "formik";

const SelectField = ({
  label,
  name,
  options = [],
  value,              // optional
  error,
  clsname = "",
  searchable = false,
  placeholder = "Select...",
  isLoading = false,
  disabled = false,

  // non-formik
  onChange,
  onBlur,
}) => {
  const formik = useContext(FormikContext);

  // ✅ AUTO value resolution
  const resolvedValue =
    value !== undefined
      ? value
      : formik && name
      ? formik.values[name]
      : "";

  const setValue = (val) => {
    if (formik && name) {
      formik.setFieldValue(name, val);
    } else if (onChange) {
      onChange(val);
    }
  };

  const setTouched = () => {
    if (formik && name) {
      formik.setFieldTouched(name, true);
    } else if (onBlur) {
      onBlur();
    }
  };

  const formattedOptions = options.map((opt) =>
    typeof opt === "string" ? { value: opt, label: opt } : opt
  );

  return (
    <div className="mb-2">
      {label && <label className={`form-label ${clsname}`}>{label}</label>}

      {searchable ? (
        <Select
          options={formattedOptions}
          value={
            formattedOptions.find((o) => o.value === resolvedValue) || null
          }
          onChange={(opt) => setValue(opt ? opt.value : "")}
          onBlur={setTouched}
          placeholder={placeholder}
          isClearable
          isLoading={isLoading}
          isDisabled={disabled}
        />
      ) : (
        <select
          className={`form-select ${error ? "is-invalid" : ""}`}
          value={resolvedValue || ""}
          onChange={(e) => setValue(e.target.value)}
          onBlur={setTouched}
          disabled={disabled}
        >
          <option value="">{placeholder}</option>
          {formattedOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      )}

      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

export default SelectField;
